import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../../shared/components/features/widget/Widget";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import PortalTechers from "../../../../assests/PortalWidget/PortalTechers.png"
import logoIsraelGoverment from "../../../../assests/PortalWidget/logoIsraelGoverment.png"
import classes from "./TeachingStaffPortalWidgwt.module.css";

const TeachingStaffPortalWidgwt = () => {

    const { texts } = useSelector(state => state.translate);
    const { general } = useSelector(state => state.uiData);

    return (
        <NavigateLink link={general.portalTeachersLink}>
            <Widget
                color="#D9D9D9"
                className={classes.TeachingStaffPortal}
            >
                <div className={classes.Portal}>
                    <div className={classes.PortalContent}>
                        <img src={PortalTechers} className={classes.PortalImg} />
                        <div className={classes.TitelContent}>
                            <div className={classes.Logo}>
                                <img src={logoIsraelGoverment} className={classes.logoIsraelGoverment} />
                                <p className={classes.LogoText}>{texts.IsraelGoverment}</p>
                            </div>
                            <p className={classes.PortalTitel}>{texts.TeachingStaffPortal}</p>
                        </div>
                    </div>
                    <div className={classes.PortalText}>
                        <p className={classes.PortalTextTitle}>{texts.TeachingStaffPortalText1}</p>
                        <p >{texts.TeachingStaffPortalText2}</p>
                    </div>
                </div>
            </Widget>
        </NavigateLink>
    );
};

export default TeachingStaffPortalWidgwt;
